import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';


// ----------------------------------------------------------------------


const initialState = {
    isLoading: false,
    error: null,
    current_shop: [],
    payments: null,
    current_payment: '',
    current_paylink: null,
    settings: {},
    onboarding: null,
    subscribers_referral_rules: null,
    shop: {},
    pstatus: null,
    last_manager_url: {
        loading: false,
        data: null,
        shop: null
    },
    managers: {
        managersList: [],
        isDelete: false,
        isLoading: false,
        isUpdate: {
            status: false,
            manager: null
        }
    }
};


const slice = createSlice({
    name: 'shops',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        stopLoading(state) {
            state.isLoading = false;
        },

        startLoadingUrl(state) {
            state.last_manager_url.loading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        setCurrentShop(state, action) {
            state.isLoading = false;
            state.current_shop = action.payload;
        },

        setPaymentsShop(state, action) {
            state.isLoading = false;
            state.payments = action.payload;
        },

        setSettingsShop(state, action) {
            state.isLoading = false;
            state.settings = action.payload;
        },

        setShop(state, action) {
            state.isLoading = false;
            state.shop = action.payload;
        },

        setCurrentPayment(state, action) {
            state.isLoading = false;
            state.current_payment = action.payload;
        },

        setCurrentPayLink(state, action) {
            state.isLoading = false;
            state.current_paylink = action.payload;
        },

        setOnBoarding(state, action) {
            state.isLoading = false;
            state.onboarding = action.payload;
        },

        setPayStatus(state, action) {
            state.isLoading = false;
            state.pstatus = action.payload;
        },

        setReferalRules(state, action) {
            state.isLoading = false;
            state.subscribers_referral_rules = action.payload;
        },
        getManagerUrl(state, action) {
            state.last_manager_url.loading = false;
            state.last_manager_url.data = action.payload;
        },
        getManagerUrlShop(state, action) {

            state.last_manager_url.shop = action.payload;
        },

        startLoadingUrl(state) {
            state.last_manager_url.loading = true;
        },
        startLoadingUpdate(state) {
            state.managers.isUpdate.status = false; // logic guessed or simple loading
            // Or maybe just generic loading?
            // redux/slices/shops.js typical usage implies loading state on specific part
            // But let's look at state structure.
        },
        stopLoadingUpdate(state) {
            // state.managers.isLoading = false? No, updateManager uses this.
        },

        startLoadingUrl(state) {
            state.last_manager_url.loading = true;
        },

        startLoadingUpdate(state) {
            // state.managers.isLoading = true; // Don't trigger list reload for single item update
        },

        stopLoadingUpdate(state) {
            // state.managers.isLoading = false;
        },

        // MANAGERS LOADING
        startManagersLoading(state) {
            state.managers.isLoading = true;
            state.error = null;
        },

        managersHasError(state, action) {
            state.managers.isLoading = false;
            state.error = action.payload;
        },

        getStatusUpdateManager(state, action) {
            state.managers.isUpdate = action.payload;
        },
        updateManagerSuccess(state, action) {
            const updatedManager = action.payload;
            state.managers.managersList = state.managers.managersList.map((manager) =>
                manager.user_id === updatedManager.user_id ? updatedManager : manager
            );
        },
        getManagersSuccess(state, action) {
            state.managers.isLoading = false;
            state.managers.managersList = action.payload;
        },
        getStatusDeleteManager(state, action) {
            state.managers.isDelete = action.payload;
        },
    }
});

// Reducer
export default slice.reducer;

// Actions
export const { actions } = slice;

// ----------------------------------------------------------------------

export function getPayments(id, tg_id = null) {

    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(`/payments/${id}?tg_id=${tg_id}`);

            // console.log(`axios response >>> ${id}` , response.data);
            if (response.data.success === false) {
                dispatch(slice.actions.hasError(response.data.data));
            }

            dispatch(slice.actions.setPaymentsShop(response.data.data));

        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    }
}

export function getShopSettings(shopid) {
    // https://api.notibot.ru/shops/{{shop_id}}/info
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(`/shops/${shopid}/info`);

            console.log(`axios INFO >>>`, response.data);
            if (response.data.success === false) {
                dispatch(slice.actions.hasError(response.data.data));
            }

            dispatch(slice.actions.setSettingsShop(response.data.data));
            dispatch(slice.actions.stopLoading());

        } catch (error) {
            dispatch(slice.actions.stopLoading());
            dispatch(slice.actions.hasError(error));
        }
    }
}


export function getShopSettingsNoAuth(shopid) {
    // https://api.notibot.ru/shops/{{shop_id}}/info
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(`/metric/shop/${shopid}`);

            console.log(`axios INFO `, response.data);
            if (response.data.success === false) {
                dispatch(slice.actions.hasError(response.data.data));
            }

            dispatch(slice.actions.setSettingsShop(response.data.data));
            dispatch(slice.actions.stopLoading());

        } catch (error) {
            dispatch(slice.actions.stopLoading());
            dispatch(slice.actions.hasError(error));
        }
    }
}

export function getShopById(shopid, act = 'onboarding') {
    // https://api.notibot.ru/shops/{{shop_id}}/info
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(`/shops/${shopid}`);
            // console.log("Слава я здесь" , response);
            if (response?.data) {
                if (act === 'onboarding') {
                    dispatch(slice.actions.setOnBoarding(response.data?.status));
                } else if (act === 'all') {
                    dispatch(slice.actions.setShop(response.data));
                } else if (act === 'referal_rules') {
                    dispatch(slice.actions.setReferalRules(response.data?.subscribers_referral_rules));
                }
            } else {
                dispatch(slice.actions.hasError(response.data));
            }
        } catch (error) {
            dispatch(slice.actions.stopLoading());
            dispatch(slice.actions.hasError(error));
        }
    }
}

export function setOnboarding(shopid, element) {
    // https://api.notibot.ru/shops/{{shop_id}}/info
    return async (dispatch) => {
        // dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(`/users/update-status?status=${element}`);

            // console.log(`axios INFO ` , response.data);
            if (response.data.success === false) {
                dispatch(slice.actions.hasError(response.data.data));
            }
            // dispatch(slice.actions.setSettingsShop(response.data.data));
        } catch (error) {
            // dispatch(slice.actions.stopLoading());
            dispatch(slice.actions.hasError(error));
        }
    }
}

// promitions/{shop_id}
export function setCurrentPayment(payment) {
    // console.log("CLICK" , shop);
    return (dispatch) => dispatch(slice.actions.setCurrentPayment(payment));
}

export function setPayLink(link) {
    // console.log("CLICK" , shop);
    return (dispatch) => dispatch(slice.actions.setCurrentPayLink(link));
}

export function setPayStatus(status) {
    // console.log("CLICK" , shop);
    return (dispatch) => dispatch(slice.actions.setPayStatus(status));
}

export function setCurShop(shop) {
    // console.log("CLICK" , shop);
    return (dispatch) => dispatch(slice.actions.setCurrentShop(shop));
}



export function getShopsList() {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get('/shops');
            if (response.data.success === false) {
                dispatch(slice.actions.hasError(response.data.data));
            } else {
                // Assuming the list is returned directly or in data
                // Based on other calls, response.data might be the payload or response.data.data
                // getShopById uses response.data
                // getPayments uses response.data.data
                // I'll assume response.data is the list for now, or check response structure if possible.
                // But for now, let's map it to current_shop as that seems to be the list in initialState.
                dispatch(slice.actions.setCurrentShop(response.data));
            }
            dispatch(slice.actions.stopLoading());
        } catch (error) {
            dispatch(slice.actions.stopLoading());
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function createShop(newShop) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.post('/shops', newShop);
            if (response.data.success === false) {
                dispatch(slice.actions.hasError(response.data.data));
                return null;
            }
            dispatch(slice.actions.stopLoading());
            return response.data; // Return the created shop data (or response)
        } catch (error) {
            dispatch(slice.actions.stopLoading());
            dispatch(slice.actions.hasError(error));
            return null;
        }
    };
}

export function updateShop(shopData) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.post('/shops', shopData);
            if (response.data.success === false) {
                dispatch(slice.actions.hasError(response.data.data));
                return null;
            }
            dispatch(slice.actions.stopLoading());
            return response.data;
        } catch (error) {
            dispatch(slice.actions.stopLoading());
            dispatch(slice.actions.hasError(error));
            return null;
        }
    };
}

export function deleteShop(id) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.delete(`/shops/${id}`);
            if (response.data.success === false) {
                dispatch(slice.actions.hasError(response.data.data));
                return false;
            }
            dispatch(slice.actions.stopLoading());
            return true;
        } catch (error) {
            dispatch(slice.actions.stopLoading());
            dispatch(slice.actions.hasError(error));
            return false;
        }
    };
}

// -------- Менеджеры ----------


export function getNewManagerUrl(shop_id) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoadingUrl());
        try {
            const response = await axios.get(`/manager_url/${shop_id}`);

            // console.log("axios response " , response);
            dispatch(slice.actions.getManagerUrl(response.data));
            dispatch(slice.actions.getManagerUrlShop(shop_id));

        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getManagersByShop(shop_id) {
    return async (dispatch) => {
        dispatch(slice.actions.startManagersLoading());
        try {
            const response = await axios.get(`/managers/${shop_id}`);
            console.log("getManagersByShop response.data:", response.data);
            dispatch(slice.actions.getManagersSuccess(response.data)); // поулчить список менеджеров магазина
            dispatch(slice.actions.getStatusDeleteManager(false)); // обнулить значение статуса удаления менеджера
        } catch (error) {
            dispatch(slice.actions.managersHasError(error));
        }
    };
}

export function updateManager(data, shop_id) {
    // console.log("DATA" , data);
    return async (dispatch) => {
        dispatch(slice.actions.startLoadingUpdate());
        dispatch(slice.actions.getStatusDeleteManager(false));
        dispatch(slice.actions.getStatusUpdateManager({ status: false, manager: data }));
        try {
            const response = await axios.post(`/managers/${shop_id}`, data);

            // console.log("axios response " , response);
            // console.log(`${response.data.enable}  ${data.enable}` );
            if (response.data.enable === data.enable) {
                // успешно обновлен статус
                dispatch(slice.actions.getStatusUpdateManager({ status: true, manager: response.data }));
                dispatch(slice.actions.updateManagerSuccess(response.data));
            }
            dispatch(slice.actions.stopLoadingUpdate());

        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function delManagerById(mid, shop_id) {
    // console.log("DEL ID" , mid);
    return async (dispatch) => {
        dispatch(slice.actions.startManagersLoading());
        try {
            const body = { data: { id: mid } };
            const response = await axios.delete(`/managers/${shop_id}`, body);
            // console.log("delete" , response);
            if (response.data.result === 'OK') {
                // удаление прошло успешно
                dispatch(slice.actions.getStatusDeleteManager(true));
                dispatch(slice.actions.getStatusUpdateManager({ status: false, manager: null }));
            }
            dispatch(slice.actions.stopManagersLoading());
        } catch (error) {
            dispatch(slice.actions.managersHasError(error));
        }
    }
}
